<template>
    <div class="container-slider-desktop">
        <h2>{{ slides.title }}  <span>{{ slides.title_span }} </span></h2>
        <div class="flex-container">
            <div ref="swiperContentContainer" class="swiper-content-container">
                <div class="swiper-wrapper">
                    <div v-for="slide in slides.list" class="swiper-slide">
                        <div class="-content">
                            <h3 class="title">{{ slide.title }}</h3>
                            <p class="text" v-html="slide.description"></p>
                            <a :href="slide.url_link" class="">
                                {{ slide.label_link }}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div ref="swiperImageContainer" class="swiper-image-container">
                <div class="swiper-wrapper">
                    <div v-for="slide in slides.list" class="swiper-slide">
                        <img class="illust" :src="slide.url_img" />
                        <a class="link" :href="slide.url_link" >
                                {{ slide.label_link }}
                        </a>
                    </div>
                </div>
            </div>
            <div class="swiper-navigation-container">
                <div ref="btnPrev" class="swiper-button-prev">
                    <svg class="icon icon-arrow"><use xlink:href="#icon-arrow"></use></svg>
                </div>
                <div ref="btnNext" class="swiper-button-next">
                    <svg class="icon icon-arrow"><use xlink:href="#icon-arrow"></use></svg>
                </div>
            </div>
        </div>
        <div class="btn-container">
            <a v-if="slides.url_link_all_projects" class="btn-lozenge -pink" :href="slides.url_link_all_projects">{{ slides.label_link_all_projects }}</a>
        </div>
    </div>
</template>

<script>
    import * as Swiper from 'swiper/js/swiper.js';

    export default {
        props: {
            slides: {
                type: Object,
                required: true,
            },
        },

        data() {
            return {
                sliderImage: null,
                sliderContent: null,
                btnContent: null
            }
        },

        beforeDestroy() {
            this.sliderImage.destroy();
            this.sliderImage = null;
            this.sliderContent.destroy();
            this.sliderContent = null;
        },

        mounted() {
            this.initSlider();
        },

        methods: {
            initSlider() {
                this.sliderImage = new Swiper (this.$refs.swiperImageContainer, {
                    pagination: false,
                    direction: 'horizontal',
                    spaceBetween: 30,
                    speed: 500,
                    slidesPerView: 2,
                    loop: true,
                    loopAdditionalSlides: 2,
                    navigation: {
                        nextEl: this.$refs.btnNext,
                        prevEl: this.$refs.btnPrev
                    },
                });
                this.sliderContent = new Swiper (this.$refs.swiperContentContainer, {
                    pagination: false,
                    direction: 'horizontal',
                    spaceBetween: 0,
                    speed: 500,
                    slidesPerView: 1,
                    loop: true,
                    navigation: {
                        nextEl: this.$refs.btnNext,
                        prevEl: this.$refs.btnPrev
                    },
                })
            }
        }
    }
</script>